import {  http, pintHttp } from "@api/client";
import { pickResponse } from "@api/utils";
import { map } from "rxjs/operators";

export const fetchReputationByVtrId = (vtrId: string) => {
  return pintHttp
    .get(`/api/v1/cmd/company/${vtrId}/reputation`)
   .pipe(
      pickResponse(),
      map((res) => res.data)
    );
};

export const fetchFactors = () => {
  return pintHttp
    .get(`/api/v1/cmd/company/reputation/factors`)
   .pipe(
      pickResponse(),
      map((res) => res.data)
    );
};

interface UpdateReputationPayload {
  override_reputation_score: number;
  override_reputation_score_reason: string;
}

export const updateCompanyReputation = (
  vtrId: string,
  payload: UpdateReputationPayload
) => {
  return http
    .put(
      `company/reputation/${vtrId}`,
      payload
    )
    .pipe(
      pickResponse(),
      map((res) => res.data)
    );
};